import styled from 'styled-components';

export const Container = styled.div`
  width: 18%;
  min-width: 100px;
  width: 50%;
  max-width: 200px;
  border-radius: 4px;
  padding: 0.2rem;
  outline: none;
  border: 2px solid var(--light-blue);
  transition: all 0.2s linear;
  display: flex;
  align-items: center;
  position: relative;

  svg {
    margin-left: 2px;
  }

  input {
    flex: 1;
    border: 0;
    background: none;
    margin-left: 5px;
    width: 100%;
    height: 100%;

    &::placeholder {
    color: var(--gray-800);
    opacity: 1;
  }
  }
`; 
